// export const customStyles = {
//   tableWrapper: {
//     style: {
//       backgroundColor: "#FFFBF4",
//       padding: "0",
//       borderRadius: "12px",
//       overflow: "hidden",
//     },
//   },

//   headRow: {
//     style: {
//       backgroundColor: "#D9A128",
//       minHeight: "52px",
//     },
//   },

//   headCells: {
//     style: {
//       fontSize: "14px",
//       fontWeight: "600",
//       color: "#ffffff",
//       backgroundColor: "#D9A128",
//     },
//   },

//   rows: {
//     style: {
//       backgroundColor: "#FFFBF4",
//       borderBottom: "1px solid #EFE6D6",
//     },
//   },

//   cells: {
//     style: {
//       backgroundColor: "#FFFBF4",
//       color: "#333",
//     },
//   },

//   pagination: {
//     style: {
//       backgroundColor: "#FFFBF4",
//       borderTop: "1px solid #EFE6D6",
//     },
//   },
// };

export const customStyles = {
  tableWrapper: {
    style: {
      backgroundColor: "transparent",
    },
  },

  table: {
    style: {
      backgroundColor: "transparent",
    },
  },

  headRow: {
    style: {
      backgroundColor: "#D9A128",
      minHeight: "50px",
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
    },
  },

  headCells: {
    style: {
      color: "#fff",
      fontWeight: "600",
      backgroundColor: "#D9A128",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      textAlign: "left",
      opacity: 1,
    },
  },

  rows: {
    style: {
      backgroundColor: "transparent",
      borderBottom: "1px solid #EFE6D6",
    },
  },

  cells: {
    style: {
      backgroundColor: "transparent",
      color: "#333",
    },
  },

  pagination: {
    style: {
      backgroundColor: "transparent",
    },
  },
};
